// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { FORGOT_PASSWORD_EMPLOYER_CHANGE_PSWD, FORGOT_PASSWORD_ADMIN_CHANGE_PSWD } from '../../../../../common/constant'
import { post } from '../../../../../common/api'

export const actionForgotPasswordEmployerChangePswd = createAsyncThunk(
    "changePasswordStore/actionForgotPasswordEmployerChangePswd",
    async (params, thunkAPI) => {
        return await post(FORGOT_PASSWORD_EMPLOYER_CHANGE_PSWD, params, thunkAPI);
    }
);

export const actionForgotPasswordAdminChangePswd = createAsyncThunk(
    "changePasswordStore/actionForgotPasswordAdminChangePswd",
    async (params, thunkAPI) => {
        return await post(FORGOT_PASSWORD_ADMIN_CHANGE_PSWD, params, thunkAPI);
    }
);

export const changePasswordSlice = createSlice({
    name: 'changePasswordStore',

    initialState: {
        //employee change password
        loadingForgotPasswordEmployerChangePswd: false,
        forgotPasswordEmployerChangePswd: null,

        //forgot password Admin CHANGE PSWD
        loadingForgotPassAdminChangePswd: false,
        forgotPasswordAdminChangePswd: null,
    },
    reducers: {
        //reset or delete public store data
        resetForgotPasswordEmployerChangePswdResponse: (state) => {
            state.forgotPasswordEmployerChangePswd = null
        },

        // Forgot Password Admin CHANGE PSWD
        resetForgotPasswordAdminChangePswdResponse: (state) => {
            state.forgotPasswordAdminChangePswd = null;
        }
    },
    extraReducers: builder => {
        builder
            //forgot password employer CHANGE PSWD
            .addCase(actionForgotPasswordEmployerChangePswd.pending, (state) => {
                state.loadingForgotPasswordEmployerChangePswd = false
            })
            .addCase(actionForgotPasswordEmployerChangePswd.fulfilled, (state, action) => {
                state.loadingForgotPasswordEmployerChangePswd = true
                state.forgotPasswordEmployerChangePswd = action.payload
            })
            .addCase(actionForgotPasswordEmployerChangePswd.rejected, (state) => {
                state.loadingForgotPasswordEmployerChangePswd = false
            })

            //forgot password Admin CHANGE PSWD
            .addCase(actionForgotPasswordAdminChangePswd.pending, (state) => {
                state.loadingForgotPassAdminChangePswd = true;
            })
            .addCase(actionForgotPasswordAdminChangePswd.fulfilled, (state, action) => {
                state.loadingForgotPassAdminChangePswd = false;
                state.forgotPasswordAdminChangePswd = action.payload;
            })
            .addCase(actionForgotPasswordAdminChangePswd.rejected, (state) => {
                state.loadingForgotPassAdminChangePswd = false;
            })
    }
})
export const { resetForgotPasswordEmployerChangePswdResponse, resetForgotPasswordAdminChangePswdResponse } = changePasswordSlice.actions

export default changePasswordSlice.reducer